export default function PHP_gettype() {
  return (
    <div>
      <h1>PHP_gettype</h1>
    </div>
  );
}
